import { Signer } from '../../signer/signer';

import { ROUTES } from '../constants';
import { AWS4SignerConfig, AWSRequestConfig, Credentials } from '../../signer';
import { auth0Signer, Auth0SignerConfig } from './auth0-signer';
import { Auth0Credentials } from '../../authenticator/auth0/types';
import { signer } from './signer';
import { isAuth0Authenticated } from '../../authenticator';

let _instance:
  | Signer<AWS4SignerConfig | Auth0SignerConfig, AWSRequestConfig, Credentials | Auth0Credentials>
  | undefined;

// SageID sign in and sign up will start from /sso/sageid page and on that
// page auth0 signer needs to be initialized. Also if there are auth0 auth fields in local storage,
// auth0 signer needs to be initialized. In all other situations Amplify signer needs to be initialized
if (window.location.pathname.includes(ROUTES.SAGE_ID_SIGN_IN_TRIGGER) || isAuth0Authenticated()) {
  _instance = auth0Signer;
} else {
  _instance = signer;
}

const appSigner = _instance;

export { appSigner };
